// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2byu9","comment":"styles_comment__1dtt5"};